export const MUNICIPAL_PROPERTY_CONSUMPTION_FEATURE_FLAG_ID = "enable-liegenschaften-consumption";
